<template>
  <div class="d-flex align-items-center">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div class="col-lg-12 col-8 font-size">
      <span :class="'badge -' + row[column.index ? column.index : column.name]">{{
        setBadgeTitle(row[column.index ? column.index : column.name])
      }}</span>
    </div>
  </div>
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";

export default {
  name: "SortTableAbsenceTypeComponent",
  components: { SortTableMobileFirstColumnComponent },
  props: {
    column: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    setBadgeTitle(type) {
      return type === "absence" ? this.$t("absence.absence") : this.$tc("absence.presence.title", 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;

  @include up-to-lg {
    width: auto;
    max-width: 130px;
  }

  &.-absence {
    background-color: var(--primary-color);
  }
  &.-presence {
    background-color: $green;
  }
}
</style>
